/**
 * Detects whether the current page is embedded in a cross-origin iframe.
 *
 * Uses `window.isInIframe` (set early in index.html) when available,
 * with a runtime fallback for other entry points.
 */
export function useIsInIframe(): boolean {
	// index.html sets this at page load — fastest path
	if (typeof (window as WindowWithIframeFlag).isInIframe === "boolean") {
		return (window as WindowWithIframeFlag).isInIframe
	}

	try {
		return window.self !== window.top
	} catch {
		// Cross-origin iframe — accessing window.top throws
		return true
	}
}

interface WindowWithIframeFlag extends Window {
	isInIframe?: boolean
}
